import { gql } from "@apollo/client";

export const CREATED_SITE = gql`
  query CreatedSiteQuery($id: Int!) {
    createdSite(id: $id) {
      ok
      error
      result {
        id
        url
        status
        creationPercentage
        requirements
        hermesDiagnostic
        createdAt
        customerId
        customer {
          id
          name
        }
        themeId
        theme {
          id
          name
        }
        promptFragmentLinks {
          id
          promptFragment {
            id
            name
          }
        }
      }
    }
  }
`;

export const CREATED_SITES = gql`
  query CreatedSitesQuery($where: CreatedSitesFiltersInput!) {
    createdSites(where: $where) {
      ok
      error
      total
      results {
        id
        url
        status
        creationPercentage
        requirements
        hermesDiagnostic
        createdAt
        customerId
        customer {
          id
          name
        }
        themeId
        theme {
          id
          name
        }
        promptFragmentLinks {
          id
          promptFragment {
            id
            name
          }
        }
      }
    }
  }
`;

export const CREATE_PROSPECTION_SITE = gql`
  mutation CreateProspectionSiteMutation(
    $customerId: Int!
    $themeId: Int
    $promptFragmentIds: [Int!]
    $requirements: String
  ) {
    createProspectionSite(
      customerId: $customerId
      themeId: $themeId
      promptFragmentIds: $promptFragmentIds
      requirements: $requirements
    ) {
      ok
      error
      createdSiteId
    }
  }
`;

export const CREATE_MANUAL_CREATED_SITE = gql`
  mutation CreateManualCreatedSiteMutation(
    $customerId: Int!
    $url: String!
    $themeId: Int
    $promptFragmentIds: [Int!]
    $requirements: String
  ) {
    createManualCreatedSite(
      customerId: $customerId
      url: $url
      themeId: $themeId
      promptFragmentIds: $promptFragmentIds
      requirements: $requirements
    ) {
      ok
      error
      createdSiteId
    }
  }
`;

export const REMOVE_CREATED_SITE = gql`
  mutation RemoveCreatedSiteMutation($id: Int!) {
    removeCreatedSite(id: $id) {
      ok
      error
    }
  }
`;

export const SITE_PROGRESS_UPDATED = gql`
  subscription SiteProgressUpdatedSubscription($createdSiteId: Int, $customerId: Int) {
    siteProgressUpdated(createdSiteId: $createdSiteId, customerId: $customerId) {
      createdSiteId
      customerId
      creationPercentage
      hermesDiagnostic
    }
  }
`;
